import { rgba } from 'polished'
import { css } from 'styled-components'

const textLink = css`
  color: inherit;
  text-decoration: solid underline ${ p => p.theme.colors.black } 1px;
  text-underline-position: under;
`

export const textLinkWithHover = css`
  ${ textLink }
  transition: background-color .3s ease-out;

  &:hover {
    background-color: ${ p => rgba( p.theme.colors.turquoise, 0.2 ) };
  }
`

export const soloTextLink = css`
  ${ p => p.theme.typo.neueHaasBold }
  font-size: ${ p => p.theme.typo.sizes.dropped };
  color: inherit;
  text-decoration-color: ${ p => p.theme.colors.turquoise };
  text-underline-offset: 3px;
`

export default textLink
